/**
 * 主数据枚举常量
 */

// 商品状态
export const ItemStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
} as const;

export const ItemStatusOptions = [
  { value: ItemStatus.ACTIVE, label: 'Active', color: 'green' },
  { value: ItemStatus.INACTIVE, label: 'Inactive', color: 'default' },
];

// 商品类型
export const ItemType = {
  NORMAL: 'NORMAL',
  WEIGHTED: 'WEIGHTED',
} as const;

export const ItemTypeOptions = [
  { value: ItemType.NORMAL, label: 'Normal' },
  { value: ItemType.WEIGHTED, label: 'Weighted' },
];

// 类目状态
export const CategoryStatus = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
} as const;

export const CategoryStatusOptions = [
  { value: CategoryStatus.ENABLED, label: 'Enabled', color: 'green' },
  { value: CategoryStatus.DISABLED, label: 'Disabled', color: 'default' },
];
